import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router';
import {
  SET_GRAPH_DATA_SETTINGS,
  SET_SENSORS_QUERY,
  TOGGLE_YEAR_VIZ,
  TOGGLE_GROUP_BY,
  TOGGLE_MIN_MAX
} from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogged: !(localStorage.getItem('user') == null),
    chartDataSettings : {
      groupBy: false,
      showMinMax: false,
      measurement: 'temperature',
      dataResolution: '1h',
      graphType: 'line',
      nets: [],
      dateRange: {
        fromDate: '',
        toDate: ''
      }
    },
  },
  mutations: {
    login(state) {
      state.isLogged = true
    },
    logout(state) {
      state.isLogged = false
      localStorage.removeItem('user')
      router.push('Welcome')
    },
    [TOGGLE_MIN_MAX](state) {
      state.chartDataSettings.showMinMax = !state.chartDataSettings.showMinMax
      state.chartDataSettings.yearsViz = false 
      state.chartDataSettings.groupBy = false
    },
    [TOGGLE_YEAR_VIZ](state) {
      state.chartDataSettings.showMinMax = false 
      state.chartDataSettings.yearsViz = !state.chartDataSettings.yearsViz 
      if (state.chartDataSettings.yearsViz) state.chartDataSettings.groupBy = 'year'
      else state.chartDataSettings.groupBy = false
    },
    [TOGGLE_GROUP_BY](state, payload) {
      state.chartDataSettings.showMinMax = false
      state.chartDataSettings.yearsViz = false 
      if (state.chartDataSettings.groupBy != payload.groupBy) state.chartDataSettings.groupBy = payload.groupBy 
      else state.chartDataSettings.groupBy = false
    },
    [SET_GRAPH_DATA_SETTINGS](state, payload) {
      state.chartDataSettings.showMinMax = false 
      state.chartDataSettings.yearsViz = false 
      state.chartDataSettings.groupBy = false 
      state.chartDataSettings.measurement = payload.measurement
      state.chartDataSettings.graphType = payload.graphType
      state.chartDataSettings.yearsViz = payload.yearsViz
    },
    [SET_SENSORS_QUERY](state, payload) {
      state.chartDataSettings.yearsViz = false 
      state.chartDataSettings.groupBy = false 
      state.chartDataSettings.showMinMax = false 
      state.chartDataSettings.nets = payload.nets
      state.chartDataSettings.dataResolution = payload.dataResolution
      let fromDate = new Date(payload.dateRange[0])
      state.chartDataSettings.dateRange.fromDate = fromDate.toISOString()
      let toDate = new Date(payload.dateRange[1] || payload.dateRange[0])
      toDate.setHours(24, 59, 0, 0)
      state.chartDataSettings.dateRange.toDate = toDate.toISOString()
      state.chartDataSettings.minmaxdata = payload.minmaxdata
    }
  },
  getters: {
    chartDataSettings: state => {
      return state.chartDataSettings
    }
  }
})
